<template>
    <div class="feed-loading-card">
    <h1>PLEASE READ: A message from The Barber 💈</h1>
      <h2>Thank you for signing up, and welcome to the Barbershop!</h2>
      <h3>We are still getting your feed ready...</h3>
      <h3>Please interact alot with our site on this first go around, <br>
        and make sure to like, dislike, and comment so we can figure out what you would want in your feed.</h3>
      <h3>Once you notice the feed is populated, we will continue to serve the news that suits you most.</h3>
      <h4> Please remember to interact with others like you would want to be treated</h4>
      <h4>and help us grow a new Social Media community that isnt as toxic as the rest.</h4>
    </div>
  </template>
  
  <script>
  
  
  export default {
  name: "notLoggedIn",
  data() {
            return {
                
            }
        },
  components: {

  },
  async mounted() {
    
  },
  computed: {
        
    },
   
  }
  </script>
  <style scoped>
  .feed-loading-card {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  

  
  .feed-loading-card h2 {
    font-size: 18px;
    color: #555;
    margin-bottom: 10px;
  }
  
  .feed-loading-card h3 {
    font-size: 16px;
    color: #777;
    margin-bottom: 20px;
  }

  .feed-loading-card h4 {
    font-size: 14px;
    color: #777;
    margin-bottom: 20px;
  }

  .feed-loading-card h5 {
    font-size: 12px;
    color: #777;
    margin-bottom: 20px;
  }
  
 
  </style>